/**
 * 권한 매트릭스용 리소스 메타 (label, sortOrder).
 * 공통코드 PERMISSION_RESOURCE 도입 전까지 프론트에서 관리합니다.
 */

export const RESOURCE_META = {
    orgs: { label: "조직 관리", sortOrder: 10 },
    boundaries: { label: "경계 설정", sortOrder: 20 },
    facilities: { label: "시설 관리", sortOrder: 30 },
    activityData: { label: "활동 데이터", sortOrder: 40 },
    activityConfigs: { label: "수집 설정", sortOrder: 50 },
    emissionFactors: { label: "배출 계수", sortOrder: 60 },
    inventories: { label: "인벤토리", sortOrder: 70 },
    inventoryWorkflows: { label: "워크플로우", sortOrder: 80 },
    reports: { label: "보고서", sortOrder: 90 },
    users: { label: "사용자", sortOrder: 100 },
    dashboard: { label: "대시보드", sortOrder: 110 },
    projects: { label: "프로젝트", sortOrder: 120 },

    // 권한 그룹 단위 리소스 (WBS: masterData/emissionBasis/emissionCalc/emissionReport)
    masterData: { label: "기본 정보 설정", sortOrder: 130 },
    emissionBasis: { label: "배출 기준 설정", sortOrder: 140 },
    emissionCalc: { label: "배출량 산정", sortOrder: 150 },
    emissionReport: { label: "배출량 보고", sortOrder: 160 },
};

/**
 * API roles 배열에서 리소스 목록 구성 (모든 역할의 permissions 키 합산, RESOURCE_META 기준 정렬)
 * @param {Array<{ permissions?: Record<string, string[]> }>} roles
 * @returns {Array<{ name: string, label: string, sortOrder: number }>}
 */
export function buildResourcesFromRoles(roles) {
    const seen = new Set();
    (roles || []).forEach((role) => {
        Object.keys(role.permissions || {}).forEach((key) => seen.add(key));
    });
    return Array.from(seen)
        .map((name) => ({
            name,
            label: RESOURCE_META[name]?.label ?? name,
            sortOrder: RESOURCE_META[name]?.sortOrder ?? 999,
        }))
        .sort((a, b) => a.sortOrder - b.sortOrder);
}
